<script>
import $ from 'jquery';

/* COMPOSANTS */
import AkFormSubmitted from '@components/general/AkFormSubmitted';
import GaMessages from '@components/ga/layout/GaMessages';
import AkButtonValidation from '@components/v2/general/AkButtonValidation.vue';
import AkButtonValidationV2 from '../v2/general/AkButtonValidationV2.vue';
import {PerfectScrollbar} from 'vue3-perfect-scrollbar';

/* MIXINS */
/* SERVICES */

export default {
  components: {PerfectScrollbar, AkButtonValidationV2, AkButtonValidation, AkFormSubmitted, GaMessages},
  props: {
    width: {type: String, default: '600px'},
    btnSuccessClass: {type: String, default: 'btn-blue'},
    btnCancelClass: {type: String, default: 'btn-grey-outline'},
    cancelLabel: {type: String, default: undefined},
    validateLabel: {type: String, default: undefined},
    autoHideOnValidate: {type: Boolean, default: false},
    autoHideOnCancel: {type: Boolean, default: true},
    showValidateButton: {type: Boolean, default: true},
    showCancelButton: {type: Boolean, default: true},
    noHeader: {type: Boolean, default: false},
    paddingOnScrollbar: {type: Boolean, default: false},
    disabled: {type: Boolean, default: false},
    title: {default: false},
    dismissable: {type: Boolean, default: false},
    contentClass: {type: String, default: ''},
    hFull: {type: Boolean, default: ''},
  },
  emits: ['show', 'hide', 'cancel', 'validate'],
  data() {
    return {
      display: false,
      submitted: false,
    };
  },
  computed: {
    buildCancelLabel() {
      return this.cancelLabel ? this.cancelLabel : this.$t('cancel');
    },
    buildValidateLabel() {
      return this.validateLabel ? this.validateLabel : this.$t('validate');
    },
  },
  mounted() {},
  methods: {
    init() {
      if (this.$refs.btnValid) this.$refs.btnValid.init();
    },
    show() {
      this.submitted = false;
      this.setDisplay(true);
      this.$emit('show');
    },
    hide() {
      this.setDisplay(false);
      this.$emit('hide');
    },
    cancel() {
      if (this.autoHideOnCancel) this.setDisplay(false);
      this.$emit('cancel');
    },
    validate() {
      this.submitted = true;
      if (this.autoHideOnValidate) this.setDisplay(false);
      this.$emit('validate');
    },
    setDisplay(value) {
      this.display = value;
    },
    success(msg) {
      this.$refs.messages.success(msg);
      this.init();
      this.scrollTop();
    },
    error(msg) {
      this.$refs.messages.error(msg);
      this.init();
      this.scrollTop();
    },
    resetMessages() {
      this.$refs.messages.resetMessages();
    },
    scrollTop() {
      $('.p-dialog-content').scrollTop(0);
    },
  },
};
</script>

<template>
  <PDialog
    :autoZIndex="false"
    v-model:visible="display"
    :modal="true"
    class="dialog-headless"
    :pt="{
      mask: {class: 'headless'},
    }"
    :style="{width: width}"
    :dismissable-mask="dismissable"
    block-scroll
    @hide="cancel"
    :closable="!this.$slots.header"
    :content-class="contentClass + ' flex-col'"
    :class="[
      {
        'no-footer': !this.showValidateButton && !this.showCancelButton && !this.$slots.footer,
        'no-header': this.noHeader,
        'default-header': !this.$slots.header,
        'padding-on-scrollbar': this.paddingOnScrollbar,
      },
    ]">
    <template #header>
      <slot name="header"></slot>
    </template>
    <GaMessages ref="messages" />
    <div class="w-full overflow-y-auto" :class="{'!px-6': this.paddingOnScrollbar, 'h-full': hFull}">
      <span v-if="title" class="font-inter font-bold text-xl text-grey-900 flex items-center justify-center mb-4">{{
        title
      }}</span>
      <AkFormSubmitted :submitted="submitted" :disabled="disabled" reference="form" :class="{'h-full': hFull}">
        <slot />
      </AkFormSubmitted>
    </div>
    <template #footer>
      <div class="flex justify-between gap-2 w-full" v-if="this.showCancelButton || this.showValidateButton">
        <span v-if="this.showCancelButton" :class="btnCancelClass" @click="cancel">
          {{ buildCancelLabel }}
        </span>
        <AkButtonValidationV2
          ref="btnValid"
          :btn-class="btnSuccessClass"
          :label="buildValidateLabel"
          :little="false"
          v-if="this.showValidateButton"
          @action="validate">
        </AkButtonValidationV2>
      </div>
      <slot name="footer" class="flex justify-between gap-2 w-full" v-else></slot>
    </template>
  </PDialog>
</template>
